export enum LocaleEnumFe {
  csCZ = 'cs-CZ',
  enUs = 'en-US',
}
